(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-partners-events"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-partners-events"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-partners-events.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-partners-events.js":
/*!********************************************!*\
  !*** ./src/mggp-plugin-partners-events.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class MggpPluginPartnersEvents
 */
var MggpPluginPartnersEvents = function (_Plugin) {
  _inherits(MggpPluginPartnersEvents, _Plugin);

  function MggpPluginPartnersEvents(player, config) {
    _classCallCheck(this, MggpPluginPartnersEvents);

    //IE fix
    var _this = _possibleConstructorReturn(this, (MggpPluginPartnersEvents.__proto__ || Object.getPrototypeOf(MggpPluginPartnersEvents)).call(this, player, config));

    if (!_this.config && !_this.player) {
      _this.player = arguments[0];
      _this.config = arguments[1];
    }

    _this._isStarted = false;

    _this._init();
    return _this;
  }

  _createClass(MggpPluginPartnersEvents, [{
    key: '_init',
    value: function _init() {
      var _this2 = this;

      this.player.on('player:stateChange', function (event) {
        if (event.data === 1 && !_this2._isStarted) {
          _this2._isStarted = true;
          _this2._sendPostMessage('mgg_start_content', { analyticsTag: '_mg' });
        }
      });

      this.player.on('ad:external:startedLoadingNewURL', function (event) {
        _this2._sendPostMessage('mgg_ask_ad', event.data);
      });

      this.player.on('ad:external:vastEvent', function (event) {
        switch (event.data.vastEvent) {
          case 'impression':
            _this2._sendPostMessage('mgg_imp_ad', event.data);
            break;
          case 'start':
            _this2._sendPostMessage('mgg_start_ad', event.data);
            _this2._sendPostMessageHasAd('mgg_has_ad_', event.data);
            break;
          case 'firstQuartile':
            _this2._sendPostMessage('mgg_1quart_ad', event.data);
            break;
          case 'midpoint':
            _this2._sendPostMessage('mgg_midpoint_ad', event.data);
            break;
          case 'thirdQuartile':
            _this2._sendPostMessage('mgg_3quart_ad', event.data);
            break;
          case 'complete':
            _this2._sendPostMessage('mgg_end_ad', event.data);
            break;
          default:
            if (/click|clickThrough|clickTracking/.test(event.data.vastEvent)) _this2._sendPostMessage('mgg_click_ad', event.data);
            break;
        }
      });

      this.player.on('ad:playerNeedStop', function (event) {
        _this2._sendPostMessage('mgg_' + event.data, event);
      });

      this.player.on('ad:element:needSkip', function (event) {
        _this2._sendPostMessage('mgg_' + event.data, event);
      });
    }
  }, {
    key: '_sendPostMessage',
    value: function _sendPostMessage(name, event) {
      if (!parent || !parent.postMessage) {
        return;
      }
      if (event.analyticsTag && event.analyticsTag.indexOf('_mg') === -1) {
        return;
      }

      parent.postMessage(name, '*');
      this.player.utils.log('MggpPluginPartnersEvents:sendPostMessage: ' + name);
    }
  }, {
    key: '_sendPostMessageHasAd',
    value: function _sendPostMessageHasAd(name, event) {
      var prefix = event.analyticsTag && event.analyticsTag.indexOf('_rb') > -1 ? '1' : '2';
      this._sendPostMessage('mgg_has_ad_' + prefix, event);
    }
  }]);

  return MggpPluginPartnersEvents;
}(_mggpPlayer.Plugin);

exports.default = MggpPluginPartnersEvents;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});